import { getTokenKey } from '@/config/axios.config';
// Set a cookie that expires in 7 days
var setCookie = function (name, value, days) {
    if (days === void 0) { days = 7; }
    var expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000); // 7 days from now
    document.cookie = "".concat(name, "=").concat(value, "; expires=").concat(expires.toUTCString(), "; path=/");
};
function getCookieValue(name) {
    var cookieArr = document.cookie.split('; ');
    var selectedCookie = cookieArr.find(function (cookie) {
        var cookieName = cookie.split('=')[0];
        return cookieName === name;
    });
    return selectedCookie ? decodeURIComponent(selectedCookie.split('=')[1] || '') : null;
}
var deleteCookie = function (name) {
    document.cookie = "".concat(name, "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/");
};
export var getToken = function () {
    var tokenKey = getTokenKey();
    var keyStructure = tokenKey.split('.');
    if (keyStructure.length === 2 &&
        (keyStructure[0].toLocaleLowerCase() === 'localstorage' ||
            keyStructure[0].toLocaleLowerCase() === 'cookie')) {
        var key = keyStructure[1];
        if (keyStructure[0].toLocaleLowerCase() === 'localstorage') {
            // Fetch value from localStorage
            var value = localStorage.getItem(key);
            try {
                // Attempt to parse the data
                return JSON.parse(value !== null && value !== void 0 ? value : '');
            }
            catch (e) {
                // If parsing fails, return the original data
                return value;
            }
        }
        else if (keyStructure[0].toLocaleLowerCase() === 'cookie') {
            // Fetch value from cookie
            return getCookieValue(key);
        }
    }
    // Return null if conditions are not met
    return null;
};
export var getTokenDetails = function (tokenKey) {
    var keyStructure = tokenKey.split('.');
    if (keyStructure.length === 2 &&
        (keyStructure[0].toLocaleLowerCase() === 'localstorage' ||
            keyStructure[0].toLocaleLowerCase() === 'cookie')) {
        return {
            type: keyStructure[0].toLocaleLowerCase(),
            key: keyStructure[1],
        };
    }
    return null;
};
// Save auth token to localStorage
export var setToken = function (token) {
    var tokenKey = getTokenKey();
    var keyStructure = tokenKey.split('.');
    if (keyStructure.length === 2 &&
        (keyStructure[0].toLocaleLowerCase() === 'localstorage' ||
            keyStructure[0].toLocaleLowerCase() === 'cookie')) {
        var key = keyStructure[1];
        if (keyStructure[0].toLocaleLowerCase() === 'localstorage') {
            // Fetch value from localStorage
            return localStorage.setItem(key, token);
        }
        else if (keyStructure[0].toLocaleLowerCase() === 'cookie') {
            // set value from cookie
            return setCookie(key, token);
        }
    }
    // Return null if conditions are not met
    return null;
};
// Remove auth token from localStorage (for logout)
export var deleteToken = function () {
    var tokenKey = getTokenKey();
    var keyStructure = tokenKey.split('.');
    if (keyStructure.length === 2 &&
        (keyStructure[0].toLocaleLowerCase() === 'localstorage' ||
            keyStructure[0].toLocaleLowerCase() === 'cookie')) {
        var key = keyStructure[1];
        if (keyStructure[0].toLocaleLowerCase() === 'localstorage') {
            // delete value from localStorage
            return localStorage.removeItem(key);
        }
        else if (keyStructure[0].toLocaleLowerCase() === 'cookie') {
            // set value from cookie
            deleteCookie(key);
        }
    }
    // Return null if conditions are not met
    return null;
};
